import React from 'react';
import {useSelector} from 'react-redux';
import {getLighterShade} from 'routes/EasyOnboard/colorUtils';
import {getSeverityColor} from '../helpers';

function ProfileSidebar({quickSummary, active, setActive, riskTier, isDev}) {
  const {userDetails} = useSelector(state => state?.auth);
  const baseColor = userDetails?.company?.color_code || '#3f7cdb';
  const lighterShade = getLighterShade(baseColor, 93);

  const menuItems = [
    {label: 'Customer Information'},
    {label: 'Financial Activity', isDisabled: !isDev},
    {label: 'Behavioral & Device Information', isDisabled: !isDev},
    {label: 'Network & Relationship Analysis', isDisabled: !isDev},
    {label: 'Location & Geographic Activity', isDisabled: !isDev},
  ];

  const summaryItems = [
    {
      label: 'Risk tier',
      value: (
        <span
          className="py-1 px-2 font-medium text-[10px]  rounded-full"
          style={{
            color: getSeverityColor(riskTier),
            backgroundColor: getSeverityColor(riskTier, 'tint'),
          }}
        >
          {riskTier || '-'}
        </span>
      ),
    },
    {
      label: 'Risk score',
      value: (
        <p className="text-[#0B1C56] text-small">
          {quickSummary?.riskScoreValue}
          <span className="font-semibold">/100</span>
        </p>
      ),
    },
    {
      label: 'Total events',
      value: (
        <p className="text-[#0B1C56] text-small">
          {quickSummary?.totalEvents || '-'}
        </p>
      ),
    },
    {
      label: 'Total cases',
      value: (
        <p className="text-[#0B1C56] text-small">
          {quickSummary?.totalCases || '-'}
        </p>
      ),
    },
    {
      label: 'Open cases',
      value: (
        <p className="text-[#0B1C56] text-small">
          {quickSummary?.totalOpenCases || '-'}
        </p>
      ),
    },
  ];

  return (
    <div className="md:w-[300px] h-fit w-full px-4 pt-4 pb-7 bg-white rounded-xl">
      <h4 className="text-deepBlue font-medium mb-4">Profile Information</h4>

      <div className="space-y-1">
        {menuItems.map(({label, isDisabled}) => {
          const isActive = label === active;
          return (
            <button
              key={label}
              style={{
                backgroundColor: isActive && lighterShade,
                border: isActive ? `1px solid #D9E5F8` : 'none',
              }}
              className={` w-full text-left text-small rounded-xl py-2 px-3 ${
                isActive
                  ? 'font-medium text-deepBlue cursor-pointer'
                  : 'font-normal text-[#5C688E]'
              } hover:bg-white80`}
              onClick={() => setActive(label)}
              disabled={isDisabled}
            >
              {label}
            </button>
          );
        })}
      </div>

      <div className="mt-8">
        <h6 className="text-xs uppercase text-[#5C688E] font-medium pb-4 border-b border-[#F6F7F9]">
          quick summary
        </h6>

        {summaryItems.map(({label, value}) => (
          <div
            key={label}
            className="flex items-center justify-between py-3 border-b border-[#F6F7F9]"
          >
            <p className="text-small text-[#858DAA]">{label}</p>
            {value}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProfileSidebar;
